import { useEffect, useRef, useState } from "react";
import { JOURNEY_STEPS } from "@/data/content";

const POINTS = [
    { x: 90, y: 340 }, { x: 180, y: 300 }, { x: 272, y: 268 }, { x: 368, y: 232 },
    { x: 472, y: 196 }, { x: 580, y: 160 }, { x: 690, y: 118 },
];
const PATH = POINTS.map((p, i) => `${i === 0 ? "M" : "L"}${p.x},${p.y}`).join(" ");

export default function Dome() {
    const [lit, setLit] = useState(0);
    const ref = useRef(null);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        let interval;
        const obs = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) return;
                obs.disconnect();
                interval = setInterval(() => {
                    setLit((l) => (l >= JOURNEY_STEPS.length ? 0 : l + 1));
                }, 900);
            },
            { threshold: 0.35 },
        );
        obs.observe(el);
        return () => {
            obs.disconnect();
            clearInterval(interval);
        };
    }, []);

    return (
        <div ref={ref} className="relative" data-testid="journey-dome">
            <svg viewBox="0 0 780 420" className="w-full" fill="none" aria-label="Founder's journey from idea to impact">
                <path d="M40 400 A350 350 0 0 1 740 400" stroke="rgba(201,162,75,0.35)" strokeWidth="1.4" />
                <path d="M90 400 A300 300 0 0 1 690 400" stroke="rgba(201,162,75,0.22)" strokeWidth="1" />
                <path d="M145 400 A245 245 0 0 1 635 400" stroke="rgba(201,162,75,0.14)" strokeWidth="0.8" />
                <path d="M205 400 A185 185 0 0 1 575 400" stroke="rgba(201,162,75,0.09)" strokeWidth="0.6" />
                <path d={PATH} stroke="rgba(232,207,143,0.85)" strokeWidth="1.6" className="dash-flow" />
                {POINTS.map((p, i) => {
                    const on = i < lit;
                    return (
                        <g key={i} style={{ transition: "opacity .6s" }}>
                            {on && (
                                <circle cx={p.x} cy={p.y} r="14" fill="none" stroke="rgba(232,207,143,0.5)" strokeWidth="1" className="pulse-soft" />
                            )}
                            <rect x={p.x - 5} y={p.y - 5} width="10" height="10"
                                transform={`rotate(45 ${p.x} ${p.y})`}
                                fill={on ? "var(--champagne)" : "#2E0C14"}
                                stroke="var(--gold)" strokeWidth="1"
                                style={{ transition: "fill .5s", filter: on ? "drop-shadow(0 0 8px rgba(232,207,143,0.8))" : "none" }} />
                            <text x={p.x} y={p.y + (i % 2 === 0 ? 30 : -20)} textAnchor="middle"
                                fill={on ? "var(--champagne)" : "rgba(168,158,140,0.75)"}
                                fontSize="11" letterSpacing="2.5"
                                style={{ textTransform: "uppercase", fontFamily: "Jost, sans-serif", transition: "fill .5s" }}>
                                {JOURNEY_STEPS[i]}
                            </text>
                        </g>
                    );
                })}
                <text x="390" y="395" textAnchor="middle" fill="rgba(201,162,75,0.6)" fontSize="10" letterSpacing="6"
                    style={{ textTransform: "uppercase", fontFamily: "Jost, sans-serif" }}>
                    The Founder's Journey
                </text>
            </svg>
        </div>
    );
}
